import React from 'react';
// Images
import GalleryImage1 from '../../assets/images/main/miss-dominatrixa-pro-domme-spanking-sub.webp';
// Constants
import { RATES_AND_TRIBUTES_URL } from '../../utils/Routes';
import { CompanyName } from '../../utils/Constants';

function SectionOne() {
  return (
    <section className='grid mb-20'>
      <div className='grid lg:grid-cols-[1fr_2fr] lg:container lg:mx-auto gap-y-4 gap-x-6 px-8 sm:px-10 md:px-20 lg:px-10 xl:gap-x-10'>
        {/* Image */}
        <div className='my-auto'>
          <img
            src={GalleryImage1}
            alt={`${CompanyName} branding`}
            className='mx-auto object-cover md:max-h-[60vh] rounded-xl shadow-cardShadow shadow-colour4/80 dark:shadow-colour4/80'
            loading='lazy'
          />
        </div>

        {/* Article */}
        <article className='grid gap-6 pt-6'>
          {/* Booking an Online Domination Session Section */}
          <section className='mb-6'>
            {/* Header */}
            <section className='grid lg:grid-cols-reg text-center lg:text-left border-b-2 border-solid border-colour3 dark:border-colour3  w-full lg:gap-x-6 pb-2'>
              <div className='hidden lg:grid items-center'>
                <h2 className='text-3xl font-titleFont tracking-widest'>
                  Booking an Online Domination Session With Me
                </h2>
              </div>
              <div className='grid lg:hidden items-center'>
                <h2 className='text-3xl font-titleFont tracking-widest'>
                  Booking an Online <br /> Domination Session With Me
                </h2>
              </div>
              <div className='hidden lg:grid items-center lg:items-start'>
                <div
                  className='h-[2px] -mt-1 bg-colour3 dark:bg-colour3'
                  role='separator'
                  aria-hidden='true'
                ></div>
              </div>
            </section>

            <div className='grid gap-4 pt-4 text-center lg:text-left'>
              <p>
                Step into my world of absolute control and submission, no matter
                where you are. My online domination sessions offer a deeply
                immersive BDSM experience through video, audio, or text-based
                interactions. Whether you crave strict discipline, sensual
                control, or psychological torment, I will take full command of
                your mind and desires from a distance.
              </p>
              <p>
                My availability is flexible, but advance booking is highly
                recommended to ensure you get the privilege of serving me at a
                time that suits both of us.
              </p>
            </div>
          </section>

          {/* How to Book Section */}
          <section className='mb-6 text-center lg:text-left'>
            <h2 className='text-xl font-bold text-colour3 dark:text-colour3 mb-4 font-castoro border-b-2 border-solid border-colour3 dark:border-colour3 pb-1 mx-auto w-fit'>
              How to Book
            </h2>
            <div className='grid gap-4'>
              <p>
                To request an online session, contact me via email with the
                following details:
              </p>
              <ul className='list-disc text-sm pl-5 space-y-2'>
                <li>Your name (a first name is sufficient for the shy ones)</li>
                <li>Preferred session date and time</li>
                <li>Your BDSM interests and experience level</li>
                <li>Desired session length</li>
                <li>
                  Session format (video, voice, text-based, or a combination)
                </li>
                <li>Specific activities or kinks you wish to explore</li>
                <li>
                  Limits, boundaries, or phobias (e.g., humiliation, pain
                  thresholds)
                </li>
                <li>Any relevant health concerns</li>
              </ul>
              <p>
                Email is the fastest and most reliable way to secure a booking.
                Ensure that you have reviewed my{' '}
                <a
                  href={RATES_AND_TRIBUTES_URL}
                  className='text-colour4 font-semibold underline'
                >
                  Rates & Tributes
                </a>{' '}
                before contacting me.
              </p>
            </div>
          </section>
        </article>
      </div>
    </section>
  );
}

export default SectionOne;
